/**
*
* ListParticipants
*
*/

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import UserText from 'components/media/UserText/Loadable.js';
import { HELLIP } from 'utils/characters.js';
import messages from './messages.js';

const SEP = '@@';
const RE = new RegExp(SEP, 'g');

function ListParticipants(props) {
  const { participants, className, limit, allowMore, markText } = props;
  const [showAll, setShowAll] = useState(false);
  function mapName(user) {
    const { archived, isDeleted, displayName } = user;
    const deleted = archived || isDeleted;
    if (!deleted) {
      return displayName;
    }
    if (markText && displayName.toLowerCase().includes(markText.toLowerCase())) {
      return `(${displayName})`;
    }
    return null;
  }
  let str = participants.map(mapName).filter(Boolean).join(SEP);
  if (!str) {
    str = participants.map(({ displayName }) => displayName && `(${displayName})`).filter(Boolean).join(SEP);
  }
  let title;
  const tooLong = limit && str.length > limit;
  if (tooLong && !showAll) {
    title = str.replace(RE, ', ');
    str = str.slice(0, limit - 4).replace(/@+$/, '') + HELLIP;
    const match = str.match(RE);
    const remaining = participants.length - Number(match && match.length) - 1;
    if (remaining > 0) {
      str += `, +${remaining}`;
    }
  }
  const message = showAll ? messages.hide : messages.showAll;
  const button = allowMore && tooLong && (
    <Button variant="link" className="text-muted p-0 ms-3 float-end" onClick={() => setShowAll(!showAll)}>
      <FormattedMessage {...message} />
    </Button>
  );
  return (
    <span title={title}>
      <UserText className={className} inline markText={markText}>{str.replace(RE, ', ')}</UserText>
      {button}
    </span>
  );
}

ListParticipants.propTypes = {
  participants: PropTypes.array.isRequired,
  className: PropTypes.string,
  limit: PropTypes.number,
  allowMore: PropTypes.bool,
  markText: PropTypes.string,
};

export default ListParticipants;
